import Model from "../../core/model/Model";
export interface TSearchResultSummary {
  phrase: string;
  responseTime: number;
  resultCount: number;
  rows: number;
  start: number;
  totalDocumentCount: number;
}

export interface ISearchResultSummary extends TSearchResultSummary {}

const SearchResultSummary = Model(
  (model: TSearchResultSummary): ISearchResultSummary => {
    const _value: TSearchResultSummary = Object.assign({}, model);

    let _model = {
      get phrase() {
        return _value.phrase;
      },
      set phrase(value) {
        _value.phrase = value;
      },
      get responseTime() {
        return _value.responseTime;
      },
      set responseTime(value) {
        _value.responseTime = value;
      },
      get resultCount() {
        return _value.resultCount;
      },
      set resultCount(value) {
        _value.resultCount = value;
      },
      get rows() {
        return _value.rows;
      },
      set rows(value) {
        _value.rows = value;
      },
      get start() {
        return _value.start;
      },
      set start(value) {
        _value.start = value;
      },
      get totalDocumentCount() {
        return _value.totalDocumentCount;
      },
      set totalDocumentCount(value) {
        _value.totalDocumentCount = value;
      }
    };
    return _model;
  }
);

export default SearchResultSummary;
